export default __webpack_public_path__ + "paddle6095a6.png";